<template>
  <v-app id="inspire">
    <v-navigation-drawer v-if="mostramenu"
      v-model="drawer"
      app
    >
      <v-list dense>
      <v-list-item 
        v-if="$store.state.config.Precheckin=='1'"
        link
        :to="'/'">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item 
        v-if="$store.state.config.Precheckin=='1'"
        link
        :to="'/home/'+this.$store.getters.reservationid">
          <v-list-item-action>
            <v-icon>mdi-account-box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Pre Check-in</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item 
        v-if="serviziopostcheckin && $store.state.config.Messaggi=='1'"
        link
        to="/msg"
        >
          <v-list-item-action>
            <v-icon>mdi-message-draw</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Messages</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item 
        v-if="serviziopostcheckin && $store.state.config.Menu=='1'"
        link
        to="/ristomenu">
          <v-list-item-action>
            <v-icon>mdi-food</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Menu del giorno</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item 
        v-if="serviziopostcheckin && $store.state.config.EstrattoConto=='1'"
        link
        to="/ec">
          <v-list-item-action>
            <v-icon>calculate</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Estratto Conto</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item 
        v-if=" $store.state.config.Documenti=='1'"
        link
        to="/docs">
          <v-list-item-action>
            <v-icon>mdi-file-document</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Documenti</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      <v-list-item 
      v-if="serviziopostcheckin && $store.state.config.Pagamenti=='1'"
      link
        to="/pags">
          <v-list-item-action>
            <v-icon class="">mdi-currency-eur</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Pagamenti</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item 
        v-if="serviziopostcheckin && false"
        link
        to="/logout">
          <v-list-item-action>
            <v-icon class="">mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      <v-list-item 
      v-if="serviziopostcheckin && false">
          <v-list-item-action>s
            <v-icon class="">mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
          </v-list-item-content>
            <v-list-item-title> {{ 'Anonimous'}}</v-list-item-title>
        </v-list-item>
      <v-list-item  
        link
        to="/info">
          <v-list-item-action>
            <v-icon class="">info</v-icon>
          </v-list-item-action>
          <v-list-item-content>
          </v-list-item-content>
            <v-list-item-title> info</v-list-item-title>
        </v-list-item>

      </v-list>

    </v-navigation-drawer>

    <v-app-bar
      app
      color="primary"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"  v-if="mostramenu" />
      <div class="d-flex align-center">
        <v-img
          alt=" Logo"
          class="shrink mr-2"
          contain
          :src="$store.state.config.LogoImageUrl"
          transition="scale-transition"
          height="55"
          width="100"
        />
        <h2 v-if="$vuetify.breakpoint.name!='xs'">{{$store.state.config.HotelName}}</h2>
      </div>

      <v-spacer></v-spacer>

            <v-btn icon @click= "setLan('en')" >
                <img  src="@/assets//eng.png"/>
            </v-btn>
             <v-btn icon @click= "setLan('it')">
                <img  src="@/assets//ita.png">
            </v-btn>
            <v-btn icon @click= "setLan('fr')"   v-if="$store.state.Labels.fr.WelcomeText!=''" >
                <img  src="@/assets//france.png">
            </v-btn>
            <v-btn icon @click= "setLan('de')"   v-if="$store.state.Labels.de.WelcomeText!=''">
                <img  src="@/assets//germany.png">
            </v-btn>
            <v-btn icon @click= "setLan('es')"   v-if="$store.state.Labels.es.WelcomeText!=''">
                <img  src="@/assets//spain.png">
            </v-btn>

    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-footer
      color="red"
      app
      v-if="mostrafootermenu"
    >
      <span class="white--text">&copy; 2019</span>
    </v-footer>

  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },
  
  data: () => ({
        items: [
          { title: 'Home', icon: 'mdi-home-city' },
          { title: 'My Account', icon: 'mdi-account' },
          { title: 'Users', icon: 'mdi-account-group-outline' },
        ],
        mini: true,
        drawer:false,
  }),
  computed:{
    mostramenu(){
      return this.$store.state.appmenuenabled;
    },

    mostrafootermenu(){
      return this.$store.state.mostrafootermenu;
    },
    serviziopostcheckin(){
      var ret = false
      if(this.$store.state.reservation){
          
          var res = this.$store.state.reservation.checkin.split('-');
          var d =new Date(res[0],Number(res[1])-1,res[2],0,0,0,0)
          var oggi = new Date();
          oggi.setHours(23, 59, 59)
          console.log("data ckin",d,oggi,(d) <= oggi);
          ret = (d) <= oggi; 
      }
      return ret;
    }
  },
      methods: {

      setLan(lingua) {
          console.log('imposta lingua',lingua)
          //window.open('https://github.com/disjfa/vuetify-sidebar-template');
          this.$store.commit("setcurrentlan",lingua);
      },
      logout(){
        this.$store.dispatch("logout").then(x=>{
          console.log(x);

        })
      },
    },
    currentu(){
        return this.$store.getters.user.email
    }
};
</script>
